import * as React from "react";
import { Box } from "grid-styled";

const UnderConstruction = ({ match }) => (
  <Box p={3}>
    <span role="img" aria-label="construction sign">
      🚧
    </span>{" "}
    {match.path} is under construction
  </Box>
);

export default UnderConstruction;



// WEBPACK FOOTER //
// ./src/components/UnderConstruction.js